import { render, staticRenderFns } from "./file_panel.vue?vue&type=template&id=68cb68cc&scoped=true&"
import script from "./file_panel.vue?vue&type=script&lang=ts&"
export * from "./file_panel.vue?vue&type=script&lang=ts&"
import style0 from "./file_panel.vue?vue&type=style&index=0&id=68cb68cc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cb68cc",
  null
  
)

export default component.exports